"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = exports.InputType = exports.InputVariant = void 0;
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var InputVariant;
(function (InputVariant) {
    InputVariant["primary"] = "primaryInput";
})(InputVariant = exports.InputVariant || (exports.InputVariant = {}));
var InputType;
(function (InputType) {
    InputType["color"] = "color";
    InputType["date"] = "date";
    InputType["datetimeLocal"] = "datetime-local";
    InputType["email"] = "email";
    InputType["file"] = "file";
    InputType["image"] = "image";
    InputType["month"] = "month";
    InputType["number"] = "number";
    InputType["password"] = "password";
    InputType["search"] = "search";
    InputType["tel"] = "tel";
    InputType["text"] = "text";
    InputType["time"] = "time";
    InputType["url"] = "url";
    InputType["week"] = "week";
})(InputType = exports.InputType || (exports.InputType = {}));
var Input = function (_a) {
    var htmlName = _a.htmlName, id = _a.id, children = _a.children, _b = _a.type, type = _b === void 0 ? InputType.text : _b, _c = _a.value, value = _c === void 0 ? "" : _c, _d = _a.isValid, isValid = _d === void 0 ? true : _d, _e = _a.placeholder, placeholder = _e === void 0 ? value : _e, _f = _a.variant, variant = _f === void 0 ? InputVariant.primary : _f, _g = _a.csx, csx = _g === void 0 ? {} : _g, _h = _a.wrapperSX, wrapperSX = _h === void 0 ? {} : _h, onChange = _a.onChange, restProps = __rest(_a, ["htmlName", "id", "children", "type", "value", "isValid", "placeholder", "variant", "csx", "wrapperSX", "onChange"]);
    return (theme_ui_1.jsx(theme_ui_1.Flex, { sx: __assign({ position: "relative", width: "100%", minHeight: __1.theme.sizes[6], border: "2px solid " + (isValid ? __1.theme.colors.grey900 : __1.theme.colors.warningRed), ":focus-within": {
                borderColor: isValid ? __1.theme.colors.primaryLight : __1.theme.colors.warningRed
            }, backgroundColor: __1.theme.colors.backgroundBlue, transition: "0.2s ease-out" }, wrapperSX) },
        theme_ui_1.jsx(theme_ui_1.Input, __assign({ name: htmlName, id: id !== null && id !== void 0 ? id : htmlName, type: type, value: value, placeholder: placeholder, variant: variant, onChange: onChange, sx: __assign({}, csx) }, restProps)),
        children));
};
exports.Input = Input;
